import script from "./GuideView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideView.vue?vue&type=script&lang=ts&setup=true"

import "./GuideView.vue?vue&type=style&index=0&id=480caca4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480caca4"]])

export default __exports__